const OnSorting = function(sort) {
  this.collection.sort = sort
  this.collection.fetchData()
}
export default OnSorting